import React, { useLayoutEffect } from "react";

import Sidebar from "./app/sidebar/Sidebar";
import Chat from "./app/Components/chat/Chat";

import Login from "./app/Components/login/Login";
import Boitevocale from "./app/Components/boitevocale/Boitevocale";
import Journal from "./app/Components/journal/Journal";
import sms from "./app/Components/sms/sms";

import Collegue from "./app/Components/collegue/Collegue";
import CollegueProfile from "./app/Components/collegue/CollegueProfile";

import Contact from "./app/Components/contact/Contact";
import AddContact from "./app/Components/contact/AddContact";
import Account from "./app/Components/profile/Account";
import Profile from "./app/Components/profile/PersonaInformation";
import Profile2 from "./app/Components/profile/PersonaInformation2";
import Parametres from "./app/Components/profile/Parametres";

// import ChatHome from "./app/Components/chat/ChatHome";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { withTranslation } from "react-i18next";

import { changeFavicon } from "./app/utils";
import Notfound from "./app/Notfound";
import SupportBoard from "./app/Components/rmc";

const poste = localStorage.getItem("poste");

function App() {
  const isAuthorized = localStorage.getItem("AccessToken") != null;

  useLayoutEffect(() => {
    document.title =
      window.switchAPI === "govoice" ? "Go Voice" : "ComunikVoIP";
    const path = "/" + window.switchAPI + ".ico";
    changeFavicon(path);
  }, []);

  if (!isAuthorized) {
    return (
      <div className="App">
        {" "}
        <Router>
          <Login />
        </Router>
      </div>
    );
  }
  return (
    <div className="App">
      <div class="relative h-screen flex overflow-hidden bg-white dark:bg-gray-800 transition-al">
        <Router>
          {/* <Fab icon={<Logo />} alwaysShowTitle={true}>
            <Webphone className="-mt-96" />
          </Fab> */}
          <Sidebar />

          <div class="flex-1 relative z-0 flex overflow-hidden">
            <main class="flex-1 relative z-0  overflow-y-auto focus:outline-none xl:order-last">
              <article>
                <Switch>
                  <Route path="/boitevocale" exact component={Boitevocale} />

                  <Route path="/" exact component={Collegue} />
                  <Route
                    path="/collegueprofil"
                    exact
                    component={CollegueProfile}
                  />

                  <Route path="/contact" component={Contact} />
                  <Route path="/addcontact" component={AddContact} />
                  <Route path="/journal" exact component={Journal} />
                  <Route path="/sms" exact component={sms} />
                  <Route path="/account" exact component={Account} />
                  <Route path="/Profile" exact component={Profile} />
                  <Route path="/Profile2" exact component={Profile2} />
                  <Route path="/parametres" exact component={Parametres} />
                  <Route path="/SupportBoard" exact component={SupportBoard} />
                  <Route path="*" exact component={Notfound} />

                  <Route path="/Chat" exact component={Chat} />
                </Switch>
              </article>
            </main>
          </div>
        </Router>
      </div>
    </div>
    // </div>
  );
}
export default withTranslation("common")(App);
